module.exports = __webpack_public_path__ + "img/safe_tool_01_SKMP.afa938db.png";